import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/mqttLog/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/mqttLog/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/mqttLog/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/mqttLog/delete/${id}`)
}
